import { graphql } from '@apollo/react-hoc';
import { gql } from 'graphql-tag';

export const query = gql`
  query GetCustomerQuickStats($input: GetCustomerQuickStatsInput!) {
    getCustomerQuickStats(input: $input) {
      segment
      segmentDisplayName
      segmentDirection
      eventsAttended
      location {
        zipcode
        city
        state
      }
      averageDaysBetweenVisits
      lastEventAttended {
        name
        date
      }
    }
  }
`;

export default graphql(query, {
  options: ({ match, accountId }) => {
    return {
      variables: {
        input: {
          user_id: Number(match.params.id),
          account_id: accountId,
        },
      },
      fetchPolicy: 'cache-and-network',
    };
  },
  name: 'quickStatsData',
});
